/** Bound browser decoders/encoders which can stop settling after a tab or renderer failure. */
export function withImageDeadline<T>(pending: Promise<T>, code: string,
  disposeLate?: (value: T) => void, milliseconds = 15_000): Promise<T> {
  return new Promise((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      settled = true;
      reject(new Error(code));
    }, milliseconds);
    pending.then(value => {
      if (settled) { try { disposeLate?.(value); } catch { /* Best-effort decoder cleanup. */ } return; }
      settled = true; clearTimeout(timer); resolve(value);
    }, error => {
      if (settled) return;
      settled = true; clearTimeout(timer); reject(error);
    });
  });
}
